import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const ConvertIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 24) / 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.2948 24.0004C14.9599 24.0004 14.7367 23.8888 14.5134 23.5539C14.4018 23.3307 14.4018 22.9958 14.5134 22.6609L15.7413 20.6517C15.9645 20.2052 16.5227 20.0936 16.8575 20.3168C17.304 20.5401 17.4157 21.0982 17.1924 21.4331L16.8575 21.9912C19.983 21.3214 22.2155 18.5308 22.2155 15.1821C22.2155 14.7356 22.5504 14.2891 23.1085 14.2891C23.6666 14.2891 24.0015 14.6239 24.0015 15.1821C24.0015 20.2052 20.0947 24.0004 15.2948 24.0004Z"
        fill="currentColor"
      />
      <path
        d="M0.781374 9.59974C0.334875 9.59974 0 9.15324 0 8.70674C0 3.90687 3.90687 0 8.70674 0C9.04162 0 9.26487 0.111625 9.37649 0.4465C9.48812 0.669749 9.48812 1.00462 9.37649 1.3395L8.14862 3.23712C7.92537 3.572 7.36724 3.79525 7.03237 3.572C6.69749 3.34875 6.47424 2.79062 6.69749 2.45575L7.03237 2.00925C3.90687 2.679 1.67437 5.358 1.67437 8.70674C1.67437 9.15324 1.22787 9.59974 0.781374 9.59974Z"
        fill="currentColor"
      />
      <path
        d="M15.0681 12.7244V15.9615C15.0681 18.6405 13.9519 19.7568 11.2729 19.7568H7.92415C5.24515 19.8684 4.12891 18.7521 4.12891 16.0732V12.836C4.12891 10.157 5.24515 9.04078 7.92415 9.04078H11.1613C13.9519 8.92916 15.0681 10.0454 15.0681 12.7244Z"
        fill="currentColor"
      />
      <path
        d="M15.9621 4.24219H12.7249C10.0459 4.24219 8.92969 5.35844 8.92969 7.92581H11.3854C14.6226 7.92581 16.1853 9.48856 16.1853 12.7257V15.1814C18.8643 15.1814 19.8689 14.0652 19.8689 11.3862V8.03743C19.7573 5.35844 18.6411 4.24219 15.9621 4.24219Z"
        fill="currentColor"
      />
    </svg>
  )
})

ConvertIcon.displayName = 'ConvertIcon'
